// src/components/Contact.jsx
import React from 'react';
import { FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';

export default function Contact() {
  return (
    <div style={{ textAlign: 'center' }}>
      <p style={{ marginTop: '0.25rem', marginBottom: '1rem' }}>
        Got an interesting project idea? Want to collaborate on something cool? Or just want to chat? I'd love to hear from you! Drop me a line through any of these channels:
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginTop: '1rem' }}>
        <a href="mailto:nikhil.goyal@iitgn.ac.in" aria-label="Email">
          <FaEnvelope size={40} />
        </a>
        <a href="https://linkedin.com/in/nikhil-4o5" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedin size={40} />
        </a>
        <a href="https://github.com/nikhil-405" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <FaGithub size={40} />
        </a>
      </div>
    </div>
  );
}
